import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import Tabs from '../../../../components/tabs/tabs.component'
import classes from './styles.module.scss';
import FullscreenClose from './fullscreen-close.component';
import AllPsdTab from '../psd-tabs/all-psd-tab.component';
import TenPsdTab from '../psd-tabs/ten-psd-tab.component';
import PsdDashboard from '../psd-tabs/dashboard.tab.component';


const PsdFullscreen = () => {
  const { t } = useTranslation();

  const tabs = [
    {
      key: 'all-psd',
      label: t('cards.psd-card.all-psd'),
    },
    {
      key: 'top-10',
      label: t('cards.psd-card.top-10'),
    },
    {
      key: 'tables',
      label: t('cards.psd-card.tables'),
    },
    {
      key: 'dashboard',
      label: t('cards.psd-card.dashboard'),
    }
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].key);

  return (
    <div className={classes['psd-fullscreen']}>
      <FullscreenClose />
      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
      <>
        {activeTab === 'all-psd' && <AllPsdTab />}
        {activeTab === 'top-10' && <TenPsdTab />}
        {activeTab === 'tables' && <div />}
        {activeTab === 'dashboard' && <PsdDashboard />}
      </>

    </div>
  )
}

export default PsdFullscreen